// Pure money formatters (no React, no storage — lib/money.ts touches
// localStorage at load, which Node tests can't have). primitives.tsx
// re-exports these, so call sites keep importing from it.

/** "$5,500" in, integer cents out. Empty clears. */
export function parseMoney(raw: string): number | null {
  const cleaned = raw.replace(/[$,\s]/g, '');
  if (cleaned === '') return null;
  const n = Number(cleaned);
  if (!Number.isFinite(n) || n < 0) return null;
  return Math.round(n * 100);
}

/** "$2,400" / "$2,400.50" — money is always mono + gold in the UI. */
export function formatMoney(cents: number | null | undefined): string {
  if (cents === null || cents === undefined) return '—';
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
  }).format(cents / 100);
}

/** "$420.00" — always two decimals (expense rows, BAS figures, invoice detail). */
export function formatMoneyExact(cents: number | null | undefined): string {
  if (cents === null || cents === undefined) return '—';
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    minimumFractionDigits: 2,
  }).format(cents / 100);
}

